import { createClient } from '@supabase/supabase-js'
import type { Database } from '@planmax/shared-types'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    'Missing Supabase environment variables. Make sure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are set.'
  )
}

/**
 * Mutable ref for the active organization ID.
 * Injected into every Supabase request as `x-active-org-id` header.
 * Updated by TenantContext on login and org switch.
 */
export const activeOrgId = { current: '' }

export const supabase = createClient<Database>(
  supabaseUrl || '',
  supabaseAnonKey || '',
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
    global: {
      fetch: (url, options = {}) => {
        const headers = new Headers(options.headers)
        // Only inject org header for PostgREST/Auth/Storage — not Edge Functions.
        // Edge functions handle auth via JWT only; the custom header would trigger
        // a CORS preflight that the functions don't need to serve.
        const urlStr = typeof url === 'string' ? url : url.toString()
        if (activeOrgId.current && !urlStr.includes('/functions/v1/')) {
          headers.set('x-active-org-id', activeOrgId.current)
        }
        return fetch(url, { ...options, headers })
      },
    },
  }
)

export type { Database }
